module.exports = __webpack_public_path__ + "img/w3_circle_down_dark.7caf8551.png";